// apps/client/src/ui/screens/menu.tsx (M0-T18) — every screen with `menu` set (filtered by mayorOnly and visible(store)), then
// Full screen (or Exit full screen; 2026-10-18, ui/fullscreen.tsx), Leave town and Sign out. Opened by the HUD's Menu button.
import { useCommands } from '../../game/instance';
import { useGame } from '../../state/store';
import type { GameStore } from '../../state/types';
import { FullscreenMenuEntry } from '../fullscreen';
import { useT } from '../i18n';
import { Button, Panel } from '../kit';
import { getScreen, menuScreens, type ScreenDef } from '../router';

declare module '../router' { interface ScreenParams { menu: undefined } }

/** The visible entries' ids as one string, so the open Menu re-renders only when that list changes (not on every clock tick). */
const entryIds = (s: GameStore): string => {
  const isMayor = s.me?.towns.find((x) => x.id === s.townId)?.role === 'mayor';
  return menuScreens(s, isMayor).map((d) => d.id).join(' ');
};

function Menu({ close }: { close: () => void }) {
  const t = useT();
  const cmd = useCommands();
  const ids = useGame(entryIds);
  const entries = ids ? ids.split(' ').flatMap((id) => getScreen(id) ?? []) : [];
  return (
    <Panel title={t('hud.menu')}>
      <nav style={{ display: 'grid', gap: 10, width: 320, maxWidth: '100%' }}>
        {entries.map((d) => (
          <Button key={d.id} variant="quiet" onClick={() => useGame.getState().openScreen(d.id, undefined as never)}>{t(d.menu!.label)}</Button>
        ))}
        <FullscreenMenuEntry />
        <Button variant="quiet" onClick={() => { close(); cmd.leaveTown(); }}>{t('hud.leaveTown')}</Button>
        <Button variant="quiet" onClick={() => { cmd.leaveTown(); void useGame.getState().signOut(); }}>{t('hud.signOut')}</Button>
      </nav>
    </Panel>
  );
}
export const screen: ScreenDef<'menu'> = { id: 'menu', layer: 'panel', component: Menu };
